import content from 'api/content.js';
import { fetchPayload } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

export const FETCH_CONTENT_METADATA = 'FETCH_CONTENT_METADATA';
export const FETCHED_CONTENT_METADATA = 'FETCHED_CONTENT_METADATA';

export const fetchContentMetadata = (contentId) => (dispatch, getState) => {
  fetchPayload({
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_CONTENT_METADATA,
    fetchedActionType: FETCHED_CONTENT_METADATA,
    apiCall: () => content.getContentMetadata(contentId),
    fetchingPayload: { contentId },
  });
};
